module.exports = require('./lib/index.js');



//////////////////
// WEBPACK FOOTER
// ./~/react-csv/index.js
// module id = 2190
// module chunks = 0